namespace $ { export class $piterjs_schedule extends $mol_view {

	/**
	 *  ```
	 *  meetup $piterjs_meetup
	 *  ```
	 **/
	@ $mol_mem
	meetup() {
		return (( obj )=>{
			return obj
		})( new this.$.$piterjs_meetup(  ) )
	}

	/**
	 *  ```
	 *  sub / <= Speeches
	 *  ```
	 **/
	sub() {
		return [this.Speeches()] as readonly any[]
	}

	/**
	 *  ```
	 *  Speeches $mol_list rows <= speeches
	 *  ```
	 **/
	@ $mol_mem
	Speeches() {
		return (( obj )=>{
			obj.rows = () => this.speeches()
			return obj
		})( new this.$.$mol_list(  ) )
	}

	/**
	 *  ```
	 *  speeches /
	 *  ```
	 **/
	speeches() {
		return [] as readonly any[]
	}

	/**
	 *  ```
	 *  Speech!index $mol_list sub /
	 *  	<= Speech_interval!index
	 *  	<= Speech_title!index
	 *  	<= Speech_speaker!index
	 *  ```
	 **/
	@ $mol_mem_key
	Speech( index : any ) {
		return (( obj )=>{
			obj.sub = () => [this.Speech_interval(index) , this.Speech_title(index) , this.Speech_speaker(index)] as readonly any[]
			return obj
		})( new this.$.$mol_list(  ) )
	}

	/**
	 *  ```
	 *  Speech_interval!index $mol_view sub / <= speech_interval!index
	 *  ```
	 **/
	@ $mol_mem_key
	Speech_interval( index : any ) {
		return (( obj )=>{
			obj.sub = () => [this.speech_interval(index)] as readonly any[]
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  speech_interval!index \19:20 - 23:50
	 *  ```
	 **/
	speech_interval( index : any ) {
		return "19:20 - 23:50"
	}

	/**
	 *  ```
	 *  Speech_title!index $mol_view
	 *  	attr * mol_theme \$mol_theme_accent
	 *  	sub / <= speech_title!index
	 *  ```
	 **/
	@ $mol_mem_key
	Speech_title( index : any ) {
		return (( obj )=>{
			obj.attr = () => ({
			"mol_theme" :  "$mol_theme_accent" ,
		})
			obj.sub = () => [this.speech_title(index)] as readonly any[]
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  speech_title!index \
	 *  ```
	 **/
	speech_title( index : any ) {
		return ""
	}

	/**
	 *  ```
	 *  Speech_speaker!index $mol_view sub / <= speech_speaker!index
	 *  ```
	 **/
	@ $mol_mem_key
	Speech_speaker( index : any ) {
		return (( obj )=>{
			obj.sub = () => [this.speech_speaker(index)] as readonly any[]
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  speech_speaker!index \
	 *  ```
	 **/
	speech_speaker( index : any ) {
		return ""
	}

} }
